import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuctionsListComponent } from './auctions-list/auctions-list.component';
import { AuctionLotCatalogComponent } from './auction-lot-catalog/auction-lot-catalog.component';
import { AuctionRegisterationComponent } from './auction-registeration/auction-registeration.component';
import { AuctionRegisterationSuccessComponent } from './auction-registeration-success/auction-registeration-success.component';
import { CoreModule } from '../../../core/core.module';
import { CommonSharedModule } from '../../../shared/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { AuctionRoutingModule } from './auction-routing.module';
import { PublicSharedModule } from '../../shared/shared.module';
import { EnquiryNowComponent } from './enquiry-now/enquiry-now.component';
import { ViewLotComponent } from './view-lot/view-lot.component';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { CountdownModule } from 'ngx-countdown';
import { AuctionStatusResolver } from './auction-status-resolver.service';
import { AuctionLotCardComponent } from './auction-lot-card/auction-lot-card.component';

@NgModule({
  declarations: [
    AuctionsListComponent,
    AuctionLotCatalogComponent,
    AuctionLotCardComponent,
    AuctionRegisterationComponent,
    AuctionRegisterationSuccessComponent,
    EnquiryNowComponent,
    ViewLotComponent,
  ],
  imports: [
    CommonModule,
    CoreModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    CommonSharedModule,
    SlickCarouselModule,
    AuctionRoutingModule,
    PublicSharedModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    CountdownModule,
  ],
  providers: [AuctionStatusResolver],
})
export class AuctionModule {}
